var CurrentUser = require("lib/account/CurrentUser");
var DropDownOptions = require("components/utility/DropDownOptions");
var LoadingButton = require("components/utility/LoadingButton");

class InformationPreferences extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false,loadingBilling: false, 
			billingHistory: null, showPaymentMethodForm: false
		};
		LuckyOrangeClient.tagComponent("InformationPreferences");
	}

	handlePersonalInformationSubmit(e) {
		$wr.nope(e)
		var firstName = this.refs.first_name.value;
		var lastName = this.refs.last_name.value;
		var title = this.refs.title.value;
		var username = this.refs.username.value;
		var email = this.refs.email.value;
		var newPassword = this.refs.new_password.value;
		var confirmedPassword = this.refs.confirmed_password.value;
		var currentPassword = this.refs.current_password.value;

		var params = { first_name: firstName, last_name: lastName, 
			title: title, username: username, email: email }

		if (newPassword || confirmedPassword || currentPassword) {
			_.extend(params, {
				password: newPassword, password_confirmation: confirmedPassword, current_password: currentPassword
				// double_password: newPassword, current_password: currentPassword
			});
		}
		var adminId = CurrentUser.get().id;
		this.setState({ loading: true })
		CurrentUser.api().patchAdmin(adminId, { admin: params }, $wr.apiHandler((response) => {
			if (response.admin.errors) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!", text: response.admin.errors.join(", "), 
					icon: "exclamation-sign", type: "error" });
				this.setState({ loading: false });
			} else {
				setTimeout(() => {
					window.wrNotifications.triggerDropDownNotification({
						title: "Information Edited", text: ("You successfully changed your account information."), 
						icon: "ok-sign" });
				}, 1000)
				CurrentUser.fetchCurrentUserData(() => {
					this.forceUpdate();
					this.setState({ loading: false });
				});
			}
		}));
	}

	render() {
		var user = CurrentUser.get();

		return (
			<form className="personalInfoForm" onSubmit={ this.handlePersonalInformationSubmit }>
				<div className="inputRow">
					<label className="inputContainer">
						First Name
						<input className="form-control" ref="first_name" 
							defaultValue={ user.first_name } />
					</label>
					<label className="inputContainer">
						Last Name
						<input className="form-control" ref="last_name" 
							defaultValue={ user.last_name } />
					</label>
					<label className="inputContainer">
						Title
						<select ref="title" defaultValue={ user.title } 
							className="form-control selectOptions">
							{ DropDownOptions.Select.Titles() }
						</select>
					</label>
				</div>
				<div className="inputRow">
					<label className="inputContainer emailInput">
						Email
						<input className="form-control" ref="email" placeholder="Enter your email"
							defaultValue={ user.email } />
					</label>
					<label className="inputContainer">
						Username
						<input className="form-control" ref="username" 
							defaultValue={ user.username } placeholder="Enter a username (optional)" />
					</label>
				</div>
				<div className="inputRow">
					<label className="inputContainer">
						Current Password
						<input type="password" className="form-control" 
							ref="current_password" />
					</label>
					<label className="inputContainer">
						New Password
						<input type="password" className="form-control" 
							ref="new_password" />
					</label>
					<label className="inputContainer">
						Confirm Password
						<input type="password" className="form-control" 
							ref="confirmed_password" />
					</label>
				</div>
				<LoadingButton className="btn buttonSuccess center-block" loading={ this.state.loading }
					text="Save Information" />
			</form>
		);
	}
}

module.exports = InformationPreferences;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/InformationPreferences.js